import React from 'react'
import Footer from './Footer'
import { Outlet, useLocation } from 'react-router-dom'
import Navbar from './Navbar'

const UserLayout = () => {
    const location = useLocation()
    const currentTab = location.pathname;
    
    return (
        <div className='flex flex-col min-h-screen'>
            <Navbar />
            <div className='flex-grow'>
                <Outlet />
            </div>
            <Footer />
        </div>
    )
}

export default UserLayout